const route = [
    {//选择作业类型
        //subject：21小学  22初中
        path: '/mathchooseType/:subject',
        component: function (resolve) {
            require(['VIEWS/math/mathchooseType.vue'], resolve);
        }
    },
    {//发作业页面  // type:1,2,3,4,5    6739141231
        // 小学#  1:知识点视频 2 同步习题 3 单元复习  4高频错题 5 速算
        // 初中#  2 同步习题 3 单元复习  4高频错题
        // sid  学科类型 21
        path: '/sx/release/:sid/:type',
        component: function (resolve) {
            require(['VIEWS/math/module/release.vue'], resolve);
        }
    },
];
export default route
